// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"iconWrapper--1hPab","title":"title--1jjlx","closeIcon":"closeIcon--2zPiO","leftBlock":"leftBlock--20tJt"};